import BannerImg from "../assets/Banner.jpg";
import TabletBannerImg from "../assets/tabletBanner.jpg";
import MobileBannerImg from "../assets/mobileBanner.jpg";
import { useI18n } from "../i18n";

const Banner = () => {
    const { t } = useI18n();

    return (
        <section className="relative flex md:h-screen max-md:h-[75vh] w-full items-center overflow-hidden">
            <picture className="absolute inset-0 size-full">
                <source media="(max-width: 768px)" srcSet={MobileBannerImg} />
                <source media="(max-width: 1024px)" srcSet={TabletBannerImg} />
                <img
                    className="size-full animate-fade-in-scale object-cover"
                    src={BannerImg}
                    alt={t("accessibility.heroImage")}
                />
            </picture>

            <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-slate-800/75 via-slate-950/40 to-transparent" />

            <div className="relative z-10 max-w-7xl px-6 md:px-16 lg:px-24">

                <h1 className="mb-5 max-w-2xl animate-[slide-up-fade_0.8s_ease-out_0.2s_both] text-5xl font-extrabold uppercase leading-[0.95] tracking-wide text-white md:text-7xl lg:text-8xl">
                    {t("hero.name")}
                    <span className="mt-2 block text-sky-300">
                        {t("hero.category")}
                    </span>
                </h1>

                <p className="max-w-lg animate-[slide-up-fade_0.8s_ease-out_0.45s_both] border-l-4 border-sky-400 pl-4 text-lg font-semibold leading-relaxed text-white md:text-2xl">
                    {t("hero.tagline")}
                </p>
            </div>
        </section>
    );
};

export default Banner;